import {BaseError} from 'viem';

const executionRevertedContractMessagePrefixes = [
  'execution reverted:',
  'VM Exception while processing transaction: revert',
  'err: ',
];

class LandCircuitBreakerActivatedError extends BaseError {
  constructor() {
    super(
      'This transaction was not accepted because it would move the market down above the permitted daily accepted ratio and halt the market.',
    );
    this.name = this.constructor.name;
  }
}

class CollateralPositionRatioNotMetError extends BaseError {
  constructor() {
    super('The transaction was not accepted because your new collateral position ratio is not above 110%.');
    this.name = this.constructor.name;
  }
}

class MinReceivedNotMetError extends BaseError {
  constructor() {
    super('The transaction was not accepted because it did not meet the minimum received you have specified.');
    this.name = this.constructor.name;
  }
}

class MarketPausedError extends BaseError {
  constructor() {
    super('This transaction was not accepted because this market is currently paused.');
    this.name = this.constructor.name;
  }
}

class InsufficientFund extends BaseError {
  constructor() {
    super(
      'Insufficient MATIC to pay for the network fee of this transaction. You can request more MATIC by selecting "Add Native Tokens" in the menu.',
    );
    this.name = this.constructor.name;
  }
}

const getCustomErrorFromRevertMessage = (revertMessage: string): BaseError | null => {
  switch (revertMessage) {
    case 'Land: Circuit breaker activated':
      return new LandCircuitBreakerActivatedError();
    case 'CP: Ratio not met':
      return new CollateralPositionRatioNotMetError();
    case 'Land: Transaction does not meet minReceived requirement':
      return new MinReceivedNotMetError();
    case 'Land: Exchange is paused':
      return new MarketPausedError();
    default:
      if (revertMessage.startsWith('insufficient funds for gas')) {
        return new InsufficientFund();
      }
      return null;
  }
};

export const getContractTransactionCustomError = (error: BaseError): BaseError => {
  const errorDetails = error.details;

  if (!errorDetails) return error;

  const knownMessagePrefix = executionRevertedContractMessagePrefixes.find(messagePrefix =>
    errorDetails.startsWith(messagePrefix),
  );

  if (!knownMessagePrefix) return error;

  const revertMessage = errorDetails.replace(knownMessagePrefix, '').trim();

  return getCustomErrorFromRevertMessage(revertMessage) ?? error;
};

export const getContractTransactionErrorStringForAnalytics = (error: Error | BaseError): string =>
  `${error.name} - ${error instanceof BaseError ? error.shortMessage : error.message}`;
